import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import Navbar from './Navbar';
import Footer from './Footer';
import { mediaUrl } from '../utils/media';

const ContactInfoPage: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
    });

    const spinner = document.getElementById('spinner');
    if (spinner) {
      setTimeout(() => {
        spinner.classList.remove('show');
      }, 500);
    }

    const backToTop = document.querySelector('.back-to-top');
    if (backToTop) {
      const handleScroll = () => {
        if (window.scrollY > 300) {
          (backToTop as HTMLElement).style.display = 'block';
        } else {
          (backToTop as HTMLElement).style.display = 'none';
        }
      };

      window.addEventListener('scroll', handleScroll);

      backToTop.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return (
    <>
      <div
        id="spinner"
        className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
      >
        <div className="spinner-grow text-primary" role="status"></div>
      </div>

      <Navbar />

      <div
        className="container-fluid page-header mb-5"
        data-aos="fade"
        data-aos-delay="100"
        style={{ background: `linear-gradient(rgba(0, 29, 35, .8), rgba(0, 29, 35, .8)), url(${mediaUrl('carousel-1.jpg')}) center center / cover no-repeat` }}
      >
        <div className="container text-center">
          <h1 className="display-4 text-white animated slideInDown mb-4" data-aos="fade-down">Contact Us</h1>
          <nav aria-label="breadcrumb animated slideInDown" data-aos="fade-down" data-aos-delay="200">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item">
                <Link to="/" className="text-white">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="text-white">Pages</span>
              </li>
              <li className="breadcrumb-item text-primary active" aria-current="page">
                Contact Us
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="100">
              <div className="bg-light rounded p-5">
                <h2 className="display-6 mb-4">Contact Us</h2>
                <p className="text-muted mb-4"><small>Last updated on 06 June 2026</small></p>
                <p className="mb-4">You may contact us using the information below:</p>

                <div className="row g-4">
                  <div className="col-12">
                    <div className="d-flex align-items-start mb-3">
                      <div className="btn-square bg-primary rounded-circle me-3 flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                        <i className="fa fa-building text-white"></i>
                      </div>
                      <div>
                        <h5 className="mb-1">Merchant Legal Entity Name</h5>
                        <p className="mb-0">HUMANITY TRUST</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="d-flex align-items-start mb-3">
                      <div className="btn-square bg-primary rounded-circle me-3 flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                        <i className="fa fa-map-marker-alt text-white"></i>
                      </div>
                      <div>
                        <h5 className="mb-1">Registered Address</h5>
                        <p className="mb-0">Plot number 45, APMC Market Kamalnagar, Kamalnagar, Karnataka, PIN: 585417</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="d-flex align-items-start mb-3">
                      <div className="btn-square bg-primary rounded-circle me-3 flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                        <i className="fa fa-map-marker-alt text-white"></i>
                      </div>
                      <div>
                        <h5 className="mb-1">Operational Address</h5>
                        <p className="mb-0">Plot number 45, APMC Market Kamalnagar, Kamalnagar, Karnataka, PIN: 585417</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="d-flex align-items-start mb-3">
                      <div className="btn-square bg-primary rounded-circle me-3 flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                        <i className="fa fa-phone-alt text-white"></i>
                      </div>
                      <div>
                        <h5 className="mb-1">Telephone No</h5>
                        <p className="mb-0"><a href="tel:9739431427">9739431427</a></p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="d-flex align-items-start mb-3">
                      <div className="btn-square bg-primary rounded-circle me-3 flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                        <i className="fa fa-envelope text-white"></i>
                      </div>
                      <div>
                        <h5 className="mb-1">E-Mail ID</h5>
                        <p className="mb-0"><a href="mailto:info@thehumanitytrust.in">info@thehumanitytrust.in</a></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <button type="button" className="btn btn-lg btn-primary btn-lg-square back-to-top" aria-label="Back to top">
        <i className="bi bi-arrow-up"></i>
      </button>
    </>
  );
};

export default ContactInfoPage;
